module.exports = __webpack_public_path__ + "img/user_placeholder.adc3e83e.png";